import React from "react";
import { Pie } from "react-chartjs-2";

const AssetAllocationChart = ({ data, options = {}, onClick, className = "", isDarkMode }) => {
  const chartOptions = {
    ...options,
    onClick,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
        labels: {
          boxWidth: 12,
          padding: 4,
          font: { size: 10 },
          color: isDarkMode ? "#fff" : "#4B5563", // gray-600 in light mode, white in dark
        },
      },
    },
  };

  return (
    <div className="w-full h-full">
      <Pie data={data} options={chartOptions} />
    </div>
  );
};

export default AssetAllocationChart;
